// src/App.js
import React, { useEffect, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import UserRoutes from './routes/UserRoutes';
import SuperAdminRoutes from './routes/SuperAdminRoutes';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// AppContext (only used for user-facing app)
import { AppProvider, AppContext } from './components/User/AppContext';

export default function App() {
  // initialize AOS once on app mount
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return <AppContent />;
}

function AppContent() {
  // We keep AppContent minimal so it can decide where to provide context
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isAdmin = hostname.startsWith('admin.');

  return (
    <BrowserRouter>
      <Toaster position="top-center" />

      {isAdmin ? (
        // Admin area — no AppProvider around it
        <SuperAdminRoutes />
      ) : (
        // User area — wrapped with AppProvider
        <AppProvider>
          <UserApp />
        </AppProvider>
      )}
    </BrowserRouter>
  );
}

function UserApp() {
  // Local consumption of AppContext (optional)
  const { loading, error } = useContext(AppContext);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        Loading…
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-red-600">
        Error loading app data.
      </div>
    );
  }

  return <UserRoutes />;
}
